<template>
        <div class="otp-box verify-modal-box">
            <div class="price-parent-modal">
                <div class="otp-msg">You have chosen to change the target exam from {{data.previousExam}} to {{data.selectedExamName}}</div>
                <v-icon class="close-icon" @click="onClose({...data, status:false})">mdi-close</v-icon>

            </div>
            
            <v-row>
                <v-col cols="12" sm="12" class="pad-zero otp-cross">
                    <div class="otp-msg">If you choose to proceed ahead by clicking "Yes" then :</div>
                    <div>
                        <ul class="desc-text">
                            <div>
                                <li v-if="data && data.subscription && data.subscription.imapact">Your subscription validity will change to <b>{{getSubcriptionDate()}}</b>
                                <v-icon class="exe-icon info-icon" @click="onClose({status: true, showPricingDetails: true, ...data})"
                                    >mdi-alert-circle</v-icon
                                ></li> 
                                <li v-else>Nothing to be change in your subscription validity</li>
                            </div>
                           <li v-if="user && user.subscription_details && user.subscription_details.find((x)=> x.name == 'AITS').is_purchased == 1">You shall no longer have access to the All India Test Series(A.I.T.S) that you purchased</li>
                        </ul>
                    </div>
                    <div class="otp-msg">Are you sure you want to proceed?</div>
                    
                </v-col>
                <div class="btn-center-align">
                    <v-btn
                        class="right-btn cust-btn resend-code-btn"
                        color="primary"
                        @click="confirmProcess('form');"
                    >Yes</v-btn>
                    <v-btn @click="onClose({...data, status:false})" class="right-btn cust-btn" color="primary">No</v-btn>
                </div>
            </v-row>
        </div>
</template>
<script>
import moment from "moment";
import { mapActions, mapState } from "vuex";
import constants from "../../utils/constants";
export default {
    name: 'PriceDetailModal',
    props: ["data", "onClose", "status"],
        data(){
            return{
                verificationCode: null,
                codeErrMessage: null,
                information:null,
                infoDialog: false,
                modalwidth: null,
                cComponent: null,
                modalheight:null,
            }
        },
        computed: {
            ...mapState("userStore", ["user"]),
        },
        methods:{
            ...mapActions({
                updateProfile: "userStore/updateProfile",
                me: "userStore/me",
            }),
            confirmProcess(type){
                let formdata = new FormData();
                
                if (type == "form") {
                    formdata.append("reqData[batch_id]", parseInt(this.data.selectedYear));
                    formdata.append("reqData[center_id]",parseInt(this.data.selectedExam));
                    if(this.user && this.user.role_id == this.roleIds.PA){
                        formdata.append("reqData[parent_student_id]",this.user.students[this.user.students.length - 1].id)
                    }
                }
                this.updateProfile(formdata)
                    .then(response => {
                        this.$toasted.success(`Exam data updated successfully`, {
                            icon: "check_circle"
                        });
                        this.me();
                        this.onClose({ status:false, isReload: true})
                    })
                    .catch(err => {});
            },
            getSubcriptionDate(){
                return this.data && this.data.subscription && this.data.subscription.subscription_date ? moment(this.data.subscription.subscription_date).format(constants.DATE_FORMATS.DISPLAY_DATE):"";
            }
        },
}
</script>